import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';

setAutoFreeze(false); // 禁止凍結

const localSchedule = JSON.parse(sessionStorage.getItem('custom-itinerary-schedule'));

const initialState = {
  name_0: localSchedule?.name_0 ?? '',
  name_1: localSchedule?.name_1 ?? '',
  name_2: localSchedule?.name_2 ?? '',
  daily_0: localSchedule?.daily_0 ?? [{ day: 0, view: [{ name: '', description: '' }] }],
  daily_1: localSchedule?.daily_1 ?? [{ day: 0, view: [{ name: '', description: '' }] }],
  daily_2: localSchedule?.daily_2 ?? [{ day: 0, view: [{ name: '', description: '' }] }],
  other_0: localSchedule?.other_0 ?? [],
  other_1: localSchedule?.other_1 ?? [],
  other_2: localSchedule?.other_2 ?? [],
  recommend: localSchedule?.recommend ?? [],
  expense: localSchedule?.expense ?? [],
};

export const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  reducers: {
    scheduleUpdate: (state, action) => {
      sessionStorage.setItem('custom-itinerary-schedule', JSON.stringify(action.payload));
      return action.payload
    },
    scheduleReset: () => {
      sessionStorage.removeItem('custom-itinerary-schedule');
      return {
        name_0: '',
        name_1: '',
        name_2: '',
        daily_0: [{ day: 0, view: [{ name: '', description: '' }] }],
        daily_1: [{ day: 0, view: [{ name: '', description: '' }] }],
        daily_2: [{ day: 0, view: [{ name: '', description: '' }] }],
        other_0: [],
        other_1: [],
        other_2: [],
        recommend: [],
        expense: [],
      };
    }
  },
});

export const scheduleSelect = (state) => state.schedule;
export const { scheduleUpdate, scheduleReset } = scheduleSlice.actions;
export default scheduleSlice.reducer;
